export * from "./wx";

/**
 * 获取对象空值
 */
const notEmptyArr = ["0", 0, false, "false"];
const canBeNull: string[] = [];
interface KeyVal {
  [key: string]: any;
}

export const filterEmpty = (obj: KeyVal) => {
  if (!obj || typeof obj !== "object") return obj;
  let o: KeyVal = {};
  Object.keys(obj).forEach((k) => {
    if (obj[k] || notEmptyArr.includes(obj[k]) || canBeNull.includes(k)) o[k] = obj[k];
  });
  return o;
};

export const arr = ["corpid", "corpId"];

/**
 * 获取url中拼接的参数
 *
 * @param {String} variable 要获取的地址栏key值 eg：Token
 * @returns
 */
export const getQueryVariable = (k?: string): any => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  let obj: KeyVal = {};
  for (let i = 0; i < vars.length; i++) {
    let [key, val] = vars[i].split("=");
    if (arr.includes(key)) key = "corpId";
    obj[key] = val;
    if (k == "corpId" && arr.includes(k)) return val;
    if (key == k) return val;
  }
  return obj;
};

export const PromiseSleep = (time: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, time));

/** 剔除千分位 */
export const formatThousands = (str: string): number => Number(str.replace(/,/g, ""));
/** 转换千分位 */
export function toThousands(value: number | string | undefined) {
  if (!value) return 0;
  // 获取整数部分
  const intPart = Math.trunc(Number(value));
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  // 预定义小数部分
  let floatPart = "";
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split(".");
  if (valueArray.length === 2) {
    // 有小数部分
    floatPart = valueArray[1].toString(); // 取得小数部分
    return intPartFormat + "." + floatPart;
  }
  return intPartFormat + floatPart;
}

/**获取字符串中的数字 */
export const getNumber = (str: string): number => Number(str.match(/\d/g)?.join("") || 0);

/** 防抖函数 */
export function debounce(fun: any, delay = 1000) {
  let timer: any;
  return (...args: any[]) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fun(...args), delay);
  };
} /** 节流函数 */
export function throttle(fun: any, delay = 1000) {
  let previous = 0;
  return async (...args: any[]): Promise<void> => {
    let now = +new Date();
    if (now - previous > delay) {
      previous = now;
      fun(...args);
    }
  };
}

/** 对象转链接参数 */
export const getUrlParams = (obj: Record<string, string>) => {
  const params = new URLSearchParams();
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      params.append(key, obj[key]);
    }
  }
  return params.toString();
};

/**
 * 判断是否是手机环境
 */
export const isWeComMobile = () => {
  let ua = navigator.userAgent.toLowerCase();
  // 检测设备类型
  let isMobile = /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone)/i.test(navigator.userAgent);
  // 检测是否为企业微信
  let isWeCom = /wxwork/i.test(ua);

  return isWeCom && isMobile;
};
